import { BankState, BankResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getAllBanks } from './bank.services';

export const initialState: BankState = {
    data: {} as BankResponse,
    status: "loading",
    error: {}
}

export const BankSlice = createSlice({
    name: 'banks',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllBanks.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getAllBanks.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getAllBanks.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const BankReducer = BankSlice.reducer